import React from 'react';

import { ContentTypesType } from 'components/ContentTypeList/types';
import { getCMSLink, getLink, linkText } from 'modules/utils/utils';
import BookmarkItem from 'components/BookMarkItem';

import styles from './styles.module.scss';
import { SocialMediaCard } from 'components/CMSModals/socialMediaCard';

type BookmarksThreeColumnProps = {
  bookmarks: any[];
  handleBookmarkClick: (contentTypeUid: string) => void;
};
const BookmarksThreeColumn: React.FunctionComponent<BookmarksThreeColumnProps> =
  ({ handleBookmarkClick, bookmarks }) => {
    return (
      <React.Fragment>
        <div className={styles.threeColumnBookmarks}>
          {bookmarks
            .slice(0, 3)
            .map((bookmark: SocialMediaCard, index: number) => (
              <BookmarkItem
                handleBookmarkClick={handleBookmarkClick}
                bookmarked={bookmark.isSaved}
                buttonLabel={linkText(bookmark.navLink)}
                description={bookmark.description}
                image={bookmark?.imageUrl}
                key={`content-types-${index}`}
                liked={bookmark.isLiked}
                likes={bookmark.likeCount}
                publicationDate={bookmark.publicationDate.toString()}
                slug={getCMSLink(bookmark.navLink)}
                threeColumn={true}
                title={bookmark.title}
                uid={bookmark.rowKey}
              />
            ))}
        </div>
      </React.Fragment>
    );
  };

export default BookmarksThreeColumn;
